/**
 * computeWritingStreak
 * Consecutive-day posting streak (UTC) from a user's posts.
 * Streak stays alive if they posted today OR yesterday. Reposts don't count.
 */

const DAY_MS = 86400000;
const dayKey = (ms) => new Date(ms).toISOString().slice(0, 10);

export function computeWritingStreak(posts, now = Date.now()) {
  const days = new Set(
    (posts || [])
      .filter((p) => !p.repostOf && p.createdAt)
      .map((p) => dayKey(new Date(p.createdAt).getTime()))
  );

  const today = dayKey(now);
  const yesterday = dayKey(now - DAY_MS);
  if (!days.has(today) && !days.has(yesterday)) return 0;

  let cursor = days.has(today) ? now : now - DAY_MS;
  let streak = 0;
  while (days.has(dayKey(cursor))) {
    streak++;
    cursor -= DAY_MS;
  }
  return streak;
}
